import { SVGProps } from ".";

export function PolylineIcon({ color = "black", size = 18 }: SVGProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        color={`${color}`}
        height={`${size}`}
        width={`${size}`}
        stroke={`${color}`}
        strokeWidth="0"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          d="M17.9844 3.2041C19.5517 3.28363 20.7979 4.57987 20.7979 6.16699C20.7976 7.80501 19.47 9.13257 17.832 9.13281C17.3217 9.13281 16.8423 9.00234 16.4229 8.77539L8.77539 16.4238C9.00221 16.8432 9.13281 17.3228 9.13281 17.833C9.13231 19.4708 7.80485 20.7986 6.16699 20.7988C4.58003 20.7988 3.28387 19.5525 3.2041 17.9854L3.2002 17.833L3.2041 17.6797C3.28367 16.1124 4.57989 14.8662 6.16699 14.8662L6.31934 14.8701C6.77188 14.8931 7.19652 15.0191 7.57324 15.2227L15.2227 7.57227C15.0193 7.19567 14.8921 6.77167 14.8691 6.31934L14.8652 6.16699L14.8691 6.01367C14.9487 4.44635 16.2449 3.2002 17.832 3.2002L17.9844 3.2041ZM6.16699 16.666C5.52273 16.666 5 17.1887 5 17.833C5.00048 18.4365 5.45913 18.9333 6.04687 18.9932L6.16699 18.999C6.77051 18.9988 7.26706 18.5399 7.32715 17.9521L7.33301 17.833C7.33301 17.1889 6.81105 16.6663 6.16699 16.666ZM17.832 5C17.1878 5 16.665 5.52273 16.665 6.16699C16.6653 6.77065 17.124 7.26725 17.7119 7.32715L17.832 7.33301C18.4357 7.33278 18.9323 6.87407 18.9922 6.28613L18.998 6.16699C18.998 5.52288 18.4761 5.00024 17.832 5Z"
          fill={`${color}`}
        />
      </svg>
    </div>
  );
}
